import graphqlClient from '@/graphql/graphql-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  UpdateOrgCompanyDocument,
  type UpdateOrgCompanyMutationVariables,
} from '@/graphql/generated/graphql';

export const useUpdateOrgCompany = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['update-org-company'],
    mutationFn: (variables: UpdateOrgCompanyMutationVariables) =>
      graphqlClient.request(UpdateOrgCompanyDocument, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });

  return {
    ...mutation,
    updateOrgCompany: mutation.mutate,
    updateOrgCompanyAsync: mutation.mutateAsync,
  };
};

export const UPDATE_COMPANY_MUTATION = UpdateOrgCompanyDocument;
